import { render, staticRenderFns } from "./video-smallNew.vue?vue&type=template&id=55842c3a&scoped=true&"
import script from "./video-smallNew.vue?vue&type=script&lang=js&"
export * from "./video-smallNew.vue?vue&type=script&lang=js&"
import style0 from "./video-smallNew.vue?vue&type=style&index=0&id=55842c3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55842c3a",
  null
  
)

export default component.exports